import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// NM 2024 theme
import Nm2024Theme from '../../nm2024Theme/colors';
// eslint-disable-next-line import/prefer-default-export
export const TypographyNm2024 = styled(Typography)`
  ${({ theme, typeface, component, variant, themeType, nextElement }) => {
    const mediumUp = theme.mediumUp();
    let thisFontFamily = "'Source Sans', 'Helvetica Neue', Helvetica, sans-serif"; // default back to guardian sans until sans-serif font is specified
    let thisFontWeight = 400;
    let thisFontSize;
    let thisTextTransform = 'none';
    let thisLineHeight;
    let thisLetterSpacing;
    let thisBottomPadding;

    /* FONT FAMILY */
    if(typeface === 'handwritten'){
      thisFontFamily = "'NM Script', 'Bradley Hand', cursive";
    }else if(typeface === 'serif'){
      thisFontFamily = "'NM Serif', Georgia, 'Times New Roman', Times, serif;";
    }

    /* FONT WEIGHT */
    if(variant === 'h3' || variant === 'h4'){
      thisFontWeight = 600;
    }else if(!variant){
      if(component === 'h3' || component === 'h4'){
        thisFontWeight = 600; // I know this is redundant, but it's the easiest, most readable way to write this expression, plus it's temporary
      }
    }

    /* Jubilee h2s */
    if(typeface === 'serif'){
      if(variant === 'h2' || (!variant && component === 'h2')){
        thisFontSize = mediumUp ? rem(34) : rem(26);
        thisLineHeight = mediumUp ? rem(37) : rem(28);
        thisTextTransform = 'uppercase';
      }
    }

    if(variant === 'h4' || (!variant && component === 'h4')){
      thisLineHeight = mediumUp ? rem(28) : rem(23);
    }

    /* letter spacing for normal body copy */
    if(typeface !== 'handwritten' && typeface !== 'serif'){
      thisLetterSpacing = rem(0.5);
    }

    if(nextElement === 'link' || nextElement === 'button'){
      thisBottomPadding = rem(28);
    }

    return css`
      ${thisFontFamily && `
        &&& {
          font-family: ${thisFontFamily};
        }
      `}
      ${thisFontSize && `
        &&& {
          font-size: ${thisFontSize};
        }
      `}
      ${thisLineHeight && `
        &&& {
          line-height: ${thisLineHeight};
        }
      `}
      ${thisLetterSpacing && `
        &&& {
          letter-spacing: ${thisLetterSpacing};
        }
      `}
      ${thisBottomPadding && `
        &&& {
          padding-bottom: ${thisBottomPadding};
        }
      `}
      && {
        font-weight: ${thisFontWeight};
        color: ${themeType === 'darkTheme' ? Nm2024Theme.neutral.white : Nm2024Theme.navy.navy};
        text-transform: ${thisTextTransform};
      }
      .nmx-sup {
          font-family: 'Source Sans', 'Helvetica Neue', Helvetica, sans-serif;
          top: -0.7em;
          font-size: 0.5em;
          left: 0.1em;
        };
    `;
  }
}`;